<script setup>
import imageHelper from '@/Helpers/image_helper.js';

const { getImage } = imageHelper.methods;

const props = defineProps({
    icon: {
        type: String
    },
    title: {
        type: String
    },
})
</script>

<template>
    <article class="w-full h-full flex flex-col gap-y-4 justify-start items-center py-5 px-4 md:px-2 bg-grayWhiteColor border border-primaryColor/10">
        <img class="h-8 md:h-10" :src="getImage(props.icon)" alt="Icon products">
        <h1 class="text-description text-center md:line-clamp-2">{{ props.title }}</h1>
    </article>
</template>
